import { transparentize } from 'polished'
import styled from 'styled-components'

import { Item } from './Item'

type Props = {
	isHighlighted: boolean
	isSelected: boolean
	isDisabled: boolean
}

export const ItemContent = styled.div<Props>`
	background-color: ${({ isHighlighted, isDisabled, isSelected, theme }) => {
		if (isHighlighted) return isDisabled ? theme.color.input.disabled : transparentize(0.6, theme.color.primary)
		if (isSelected)
			return isDisabled ? transparentize(0.8, theme.color.primary) : transparentize(0.86, theme.color.primary)
		return isDisabled ? theme.color.disabledContrast : theme.color.input.background
	}};
	display: flex;
	padding: 8px 10px;
	border-radius: 4px;
	transition: background-color 135ms ease;
	align-items: center;
	justify-content: space-between;
	column-gap: 8px;

	${Item}:hover {
		background-color: ${({ theme, isDisabled }) => (isDisabled ? theme.color.input.disabled : transparentize(0.6, theme.color.primary))};
	}
`
